import Input from "../../../components/FormComponents/Input";
import { STATUS_OPTIONS, toLocalDatetimeString, toUTCISOString } from "../utils";

const FilterField = ({ label, children }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
    <label className="builder_label">{label}</label>
    {children}
  </div>
);

const AuditFilterSection = ({ filters, options, onFilterChange, onAppChange, onWfChange, subjectLabel }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: "12px",
        padding: "12px 0px",
        borderRadius: "6px"
      }}
    >
      <FilterField label="Application">
        <select
          className="builder_input w_100"
          value={filters.app_id || ""}
          onChange={(e) => onAppChange(e.target.value || undefined)}
        >
          <option value="">All applications</option>
          {(options.apps || []).map((app) => (
            <option key={app.app_id} value={app.app_id}>
              {app.app_name}
            </option>
          ))}
        </select>
      </FilterField>

      <FilterField label="Workflow">
        <select
          className="builder_input w_100"
          value={filters.wf_id || ""}
          onChange={(e) => onWfChange(e.target.value || undefined)}
        >
          <option value="">All workflows</option>
          {(options.workflows || []).map((wf) => (
            <option key={wf.wf_id} value={wf.wf_id}>
              {wf.wf_name}
            </option>
          ))}
        </select>
      </FilterField>

      <FilterField label="Activity">
        <select
          className="builder_input w_100"
          value={filters.activity_id || ""}
          onChange={(e) => onFilterChange("activity_id", e.target.value || undefined)}
        >
          <option value="">All activities</option>
          {(options.activities || []).map((act) => (
            <option key={act.activity_id} value={act.activity_id}>
              {act.activity_name}
            </option>
          ))}
        </select>
      </FilterField>

      <FilterField label="Instance">
        <select
          className="builder_input w_100"
          value={filters.instance_id || ""}
          onChange={(e) => onFilterChange("instance_id", e.target.value || undefined)}
        >
          <option value="">All instances (recent 50)</option>
          {(options.instances || []).map((id) => (
            <option key={id} value={id}>
              {id}
            </option>
          ))}
        </select>
      </FilterField>

      <FilterField label="Status">
        <select
          className="builder_input w_100"
          value={filters.status || ""}
          onChange={(e) => onFilterChange("status", e.target.value || undefined)}
        >
          {STATUS_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </FilterField>

      <FilterField label="User Email">
        <Input
          inputBoxStyle={{ height: "30px" }}
          placeholder="Filter by user email"
          value={filters.user_email || ""}
          onChange={(e) => onFilterChange("user_email", e.target.value || undefined, { debounce: true })}
        />
      </FilterField>

      <FilterField label={subjectLabel || "Identifier"}>
        <Input
          inputBoxStyle={{ height: "30px" }}
          placeholder={subjectLabel ? `Search ${subjectLabel}` : "Search identifier (truck/customer id…)"}
          value={filters.subject || ""}
          onChange={(e) => onFilterChange("subject", e.target.value || undefined, { debounce: true })}
        />
      </FilterField>

      <FilterField label="From Date">
        <Input
          inputBoxStyle={{ height: "30px" }}
          type="datetime-local"
          value={toLocalDatetimeString(filters.from_date)}
          onChange={(e) => onFilterChange("from_date", toUTCISOString(e.target.value))}
        />
      </FilterField>

      <FilterField label="To Date">
        <Input
          inputBoxStyle={{ height: "30px" }}
          type="datetime-local"
          value={toLocalDatetimeString(filters.to_date)}
          onChange={(e) => onFilterChange("to_date", toUTCISOString(e.target.value))}
        />
      </FilterField>
    </div>
  );
};

export default AuditFilterSection;
